module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "protocol-results"
  }, [_c('div', {
    staticClass: "protocol",
    attrs: {
      "id": _vm.protocol._id
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.link,
      "tag": "h2"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.info(_vm.protocol, "title")))])]), _vm._v(" "), (_vm.info(_vm.protocol, 'time-estimate')) ? _c('div', {
    attrs: {
      "id": "time"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.info(_vm.protocol, 'time-estimate')))])]) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "id": "author"
    }
  }, [_c('span', [_vm._v("Author: " + _vm._s(_vm.info(_vm.protocol, "author")) + " ")]), _vm._v(" "), (_vm.info(_vm.protocol, 'partner')) ? _c('span', [_vm._v("| Partner: " + _vm._s(_vm.info(_vm.protocol, "partner")) + " ")]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.info(_vm.protocol, 'description')))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d3e1b084!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProtocolPreview.vue
// module id = 248
// module chunks = 2